import { gofor } from '@fiverr-private/futile/lib/gofor/index';
import { metric } from '@fiverr-private/perseus';

const getGigs = ({url, type}) => new Promise((resolve, reject) => {
    gofor(url)
        .then((response) => {
            if (!response.ok) {
                metric.count(`bad_response.carousels.${response.status}.${type}`);
                reject();
            } else {
                response.json().then(({gigs}) => {
                    if (gigs.length) {
                        resolve(gigs);
                    } else {
                        reject();
                    }
                });
            }
        });
});

export default getGigs;
